<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="5"/>
    <div class="h_zp_zx">
      <div class="w1200">
        <ul>
          <li><img src="../../assets/images/x_icon.png" alt="互联网技术+"><span>互联网技术+</span></li>
          <li><img src="../../assets/images/x_icon1.png" alt="中国制造2025"><span>中国制造2025</span></li>
          <li><img src="../../assets/images/x_icon2.png" alt="一带一路"><span>一带一路</span></li>
        </ul>
      </div>
    </div>
    <div class="h_zp_zx_content">
      <div class="w1200">
        <h2 style="font-size: 28px;font-weight: bold;color: #07357b;margin-bottom: 20px;">“互联网技术+工业MRO构建制造新型产业电商业态</h2>
        <div style="font-size: 15px;font-weight: normal;color: #333333;line-height: 2;text-indent: 2em;">
          在国家大力倡导“互联网+”、“中国制造2025”、“一带一路”国家战略的促进下，互联网、云计算、大数据等新兴技术正在加速融入实体产业，未来如何以互联网技术+工业MRO构建制造新型产业电商业态，培育经济发展的新动能。当互联网+上升为国家经济发展战略高度后，围绕着工业制造，国家不断地出台建立工业互联网化平台，打造供应链协同运作体系，共建新型互联网+工业品MRO产业生态圈的新格局。
        </div>
      </div>
    </div>
    <div class="Commerce">
      <div class="w1200 clearfix">
        <div class="Commerce_left">
          <h2 style="font-size: 38px;color: #07357b;font-weight: normal;padding: 60px 0 15px;">志鹏供应链</h2>
          <span style="font-size: 22px;color: #999999;display: block;margin-bottom: 35px;">一家集产品批发、零售为一体的经营企业</span>
          <div style="font-size: 15px;font-weight: normal;color: #333333;line-height: 2;text-indent: 2em;">
            志鹏供应链（内蒙古）有限公司（志鹏工业品采购平台：www.nmzp.com）成立于2003年，是一家集产品批发、零售为一体的经营企业，主要为设备维护、修理和运作（MRO）等工业用品的采购服务。经过线下近20年的探索与积累，针对内蒙古地区工业品备品备件生产厂家稀少，资源匮乏，采购方式、采购品种和采购地点选择余地较窄的情况下，志鹏供应链智能采购服务平台帮助每位客户持续降低工业用品的采购和管理成本，为企业提供运营所需的各种辅料和易耗品。平台拥有全面多样的产品组合，横跨20多个产品线，超过100,000多种国内外知名品牌工业产品，确保最大程度满足客户的产品选择需求。作为一站式工业用品采购平台，实现公司及制造业与中小企业的在线对接，具有工业品采购、审批、物流、结算等的一站式互联网采购解决方案。
          </div>
        </div>
        <div class="Commerce_right">
          <img src="../../assets/images/xj_image.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="Platfor">
      <h2>一站式智能采购服务平台</h2>
      <span>One-stop Intelligent Purchasing Service Platfor</span>
      <div class="w1200">
        <ul>
          <li class="gypcg">
            <img src="../../assets/images/xj_icon1.png" alt="工业品采购">
            <span>工业品采购</span>
          </li>
          <li class="sp">
            <img src="../../assets/images/xj_icon2.png" alt="审批">
            <span>审批</span>
          </li>
          <li class="wl">
            <img src="../../assets/images/xj_icon3.png" alt="物流">
            <span>物流</span>
          </li>
          <li class="js">
            <img src="../../assets/images/xj_icon4.png" alt="结算">
            <span>结算</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="Solutions">
      <h2>我们的解决方案</h2>
      <span>Our Solutions</span>
      <ul>
        <li>
          <img src="../../assets/images/xj_img5.jpg" alt="梳理产品、统一标准">
          <div>
            <span>01.梳理产品、统一标准</span>
            <em>
              梳理产品名称、规格、型号等产品清单，统一产品标准化，通过一站式的集采平台满足客户工业品采购的便捷体验。
            </em>
          </div>
        </li>
        <li class="ygcg">
          <img src="../../assets/images/xj_img6.jpg" alt="阳光采购、价格透明">
          <div>
            <span>02.阳光采购、价格透明</span>
            <em>
              合作企业实现专属协议折扣价格，线上价格阳光透明便于查看及采购，为企业提供有效降本解决方案。
            </em>
          </div>
        </li>
        <li class="jhlc">
          <img src="../../assets/images/xj_img7.jpg" alt="简化流程、提升效率">
          <div>
            <span>03.简化流程、提升效率</span>
            <em>
              实现流程可控且规范化管理，简化流程大幅提升审批效率，从而大幅降低企业容易忽视的隐形流程成本。
            </em>
          </div>
        </li>
        <li class="bbtj">
          <img src="../../assets/images/xj_img8.jpg" alt="报表统计、数据分析">
          <div>
            <span>04.报表统计、数据分析</span>
            <em>
              订单数据及汇总报表分析等功能，提高管理效率，多维度数据分析，为管理人员实时监控采购数据提供高效工具。
            </em>
          </div>
        </li>
      </ul>
    </div>
    <!-- 我们的解决方案 -->
    <div class="Provide">
      <div class="Provide-top"></div>
      <div class="w1200">
        <h3>行业专家提供产品选择、技术咨询、订单执行、发票开具、售后维权等全流程跟踪</h3>
        <i>Provide product selection, technical consultation, order execution, invoicing, and after-sales rights protection</i>
        <img src="../../assets/images/xj_icon5.png" alt="">
        <span>行业专家提供产品选择、技术咨询、订单执行、发票开具、售后维权等全流程跟踪，确保采购过程中的问题快速解决。<br>
        同时进一步打通供需上下游，重新梳理公司相关业务，<br>
        降低了管理成本，提高了公司自身的供应链效率，通过自营供应链、搭建服务网络为终端企业客户提供优质高性价比的产品与贴身便捷的服务。</span>
      </div>
    </div>
    <div class="industrial">
      <ul>
        <li><img src="../../assets/images/xj_img9.jpg" alt=""></li>
        <li>
          <h3 style="font-size: 28px;color: #07357b;margin: 0 25px 0 45px;">提高采购效率，优化产业结构</h3>
          <span style="font-size: 15px;font-weight: normal;color: #333333;line-height: 2;margin: 0 25px 0 45px;display: block;margin-top: 20px;">提供线上线下咨询，实现工业品流通的“线上与线下”对接，改变消费模式，从传统的2B和2C模式转变为移动互联网模式，打造MRO供应链平台，链接品牌商和客户，从产品、价格、物流、服务、数据等方面帮助上下游提升采购效率，优化传统产业结构。</span>
        </li>
      </ul>
    </div>
    <div class="Docking">
      <h2>数字化对接解决方案</h2>
      <span>Digital Docking Solution</span>
      <img src="../../assets/images/xj_icon6.png" alt="">
      <em>缩短供应链货期、确保正品行货、降低采购成本、保障服务质量</em>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'About',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
  .atpresent_title{
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/view/about/index.vue